import cx from 'classnames'
import { useMemo } from 'react'
import CustomPhotosHeaderSlidingContent, {
  PhotoWithOrientation,
} from './CustomPhotosHeaderSlidingContent'
import cutoutHeaderRegular from '../assets/landing/header-cutout-post-purchase-modal.png'
import staticHeaderRegular from '../assets/landing/header-static-post-purchase-modal.png'
import { CuratedPhotoForPhotoProducts, FrameConfiguration } from '../types'

// Regular configuration
const REGULAR_WIDTH = 780
const REGULAR_HEIGHT = 1074

const DPF_JP_FRAMES_REGULAR: FrameConfiguration = {
  width: REGULAR_WIDTH,
  height: REGULAR_HEIGHT,
  requiredPhotos: 6,
  frames: [
    {
      left: (168 / REGULAR_WIDTH) * 100,
      top: (374 / REGULAR_HEIGHT) * 100,
      width: (435 / REGULAR_WIDTH) * 100,
      height: (273 / REGULAR_HEIGHT) * 100,
      rotate: 0,
    },
  ],
}

// Post Purchase Modal Header doesn't support holiday or new year themes
export default function CuratedPhotosHeaderForPostPurchaseModal({
  curatedPhotos,
  isUsingFallback,
  frameOffsets,
  cutoutImageClassName,
}: {
  curatedPhotos: CuratedPhotoForPhotoProducts[]
  isUsingFallback: boolean
  frameOffsets?: Array<{
    left: number
    top: number
    scale?: number
    rotate?: number
    zIndex?: number
  }>
  cutoutImageClassName?: string
}) {
  const photos: PhotoWithOrientation[] = useMemo(
    () =>
      isUsingFallback
        ? []
        : curatedPhotos.map(photo => ({
            url: photo.croppedUrl,
            isLandscape:
              !!photo.imageWidth && !!photo.imageHeight && photo.imageWidth > photo.imageHeight,
          })),
    [isUsingFallback, curatedPhotos],
  )

  const frameConfiguration = DPF_JP_FRAMES_REGULAR
  const staticHeaderImage = staticHeaderRegular

  // Use requiredPhotos from frame configuration
  if (photos.length < frameConfiguration.requiredPhotos) {
    return (
      <img
        src={staticHeaderImage}
        className={cx('w-full h-full object-cover', cutoutImageClassName)}
        loading='eager'
        width={frameConfiguration.width}
        height={frameConfiguration.height}
        style={{ aspectRatio: `${frameConfiguration.width}/${frameConfiguration.height}` }}
        alt='Header image'
      />
    )
  }

  return (
    <CustomPhotosHeaderSlidingContent
      photos={photos}
      frameOffsets={frameOffsets}
      cutoutImageClassName={cutoutImageClassName}
      cutoutImage={cutoutHeaderRegular}
      frameConfiguration={frameConfiguration}
    />
  )
}
